import { render } from "./CardNotification.vue?vue&type=template&id=cb0461dc&scoped=true"
import script from "./CardNotification.vue?vue&type=script&lang=js"
export * from "./CardNotification.vue?vue&type=script&lang=js"

import "./CardNotification.vue?vue&type=style&index=0&id=cb0461dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0461dc"]])

export default __exports__